export default {
    isLoading(state) {
        return state.loading;
    }
};
